/* The Unlucky Cass — Dark/Light Mode Toggle */
(function () {
  var STORAGE_KEY = 'uc-theme';
  var html = document.documentElement;

  function applyTheme(theme) {
    if (theme === 'dark') {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.removeAttribute('data-theme');
    }
  }

  function getPreference() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function savePreference(theme) {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {}
  }

  // Apply on load (before paint to avoid flash)
  var saved = getPreference();
  if (saved) {
    applyTheme(saved);
  }
  // Default: light (no attribute needed)

  // Wire up toggle button after DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('uc-theme-toggle');
    if (!btn) return;

    var current = getPreference() || 'light';
    applyTheme(current);

    btn.addEventListener('click', function () {
      var next = html.hasAttribute('data-theme') ? 'light' : 'dark';
      applyTheme(next);
      savePreference(next);
    });
  });
})();
